module.exports = __webpack_public_path__ + "img/BackArrow.acc39487.svg";